import { TCarGroup, TCarStatus } from './types';

/* eslint-disable import/prefer-default-export */
export const TOOLTIP_TEXT = {
  price:
    'Цена рассчитывается согласно выбранным параметрам в блоках «Рассчитайте кредит» и «Используйте trade-in»',
  priceRetail:
    'Рекомендованная розничная цена автомобиля без учета выгод, для применения выгод воспользуйтесь модулями «Рассчитать кредит», «Используйте Trade-in» и блоком «Подробнее о цене»',
  dealerPriceRetail:
    'Цена автомобиля без учета выгод, для применения выгод воспользуйтесь модулями «Рассчитать кредит», «Используйте Trade-in» и блоком «Подробнее о цене»',
  monthly:
    'Воспользуйтесь блоком «Рассчитайте кредит» для изменения ежемесячного платежа',
  initialPayment:
    'Воспользуйтесь стоимостью сдаваемого автомобиля в качестве первоначального взноса для расчёта кредита, выгода по программе применится автоматически',
  tradeIn:
    'Выгода по программе Trade-in рассчитывается исходя из параметров, выбранных в блоке «Используйте Trade-in»',
  tradeInPrice:
    'Стоимость Вашего автомобиля рассчитывается исходя из параметров, указанных в блоке «Используйте Trade-in»',
  suzukiFinance:
    'Выгода по программе Suzuki Finance рассчитывается исходя из параметров, выбранных в блоке «Рассчитайте кредит»',
};

export const EVENT_ON_GA_TRACKING = 'gaTracking';

export const FORM_IDS = {
  bookingCar: 'booking-car-form',
} as const;

export const DEFAULT_STATE_FILTER: TCarStatus[] = ['active', 'transit'];

export const STATE_TITLE_MAP: Record<TCarStatus, string> = {
  active: 'В наличии',
  transit: 'В пути',
  sold: 'Продан',
  distributed: 'В производстве',
};

export const DEFAULT_STATE_FILTER_VALUES = DEFAULT_STATE_FILTER.map(v => ({
  value: v,
  title: STATE_TITLE_MAP?.[v],
}));

export const DEFAULT_GROUP_FILTER: TCarGroup[] = ['new', 'used'];

export const GROUP_TITLE_MAP: Record<TCarGroup, string> = {
  new: 'Новый',
  used: 'С пробегом',
};

export const DEFAULT_GROUP_FILTER_VALUES = DEFAULT_GROUP_FILTER.map(v => ({
  value: v,
  title: GROUP_TITLE_MAP[v],
}));
